import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../actions/configApi';

export const fetchUserProposals = createAsyncThunk(
  'proposals/fetchUserProposals',
  async ({ page = 1 }, { rejectWithValue }) => {
    try {
      const response = await api.get(`proposals-user?page=${page}`);
      // Espera que a resposta tenha a estrutura: { data: [...], total, current_page, last_page }
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const updateBankData = createAsyncThunk(
  'proposals/updateBankData',
  async ({ token, bank_data }, { rejectWithValue }) => {
    try {
      const response = await api.put(`proposals/${token}/bank-data`, { bank_data });
      // Espera que a resposta contenha { proposalId, bank_data }
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

const proposalsSlice = createSlice({
  name: 'proposals',
  initialState: {
    proposals: [],       // Propostas armazenadas aqui
    totalItems: 0,
    currentPage: 1,
    itemsPerPage: 10,
    loading: false,
    error: null,
    successMessage: null,
    searchTerm: '',
    sortDirection: 'desc',
    updatedProposalId: null,
  },
  reducers: {
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setSearchTerm: (state, action) => {
      state.searchTerm = action.payload;
      state.currentPage = 1;
    },
    setSortDirection: (state, action) => {
      state.sortDirection = action.payload;
      state.currentPage = 1;
    },
    clearUpdatedProposalId: (state) => {
      state.updatedProposalId = null;
    },
    clearMessages: (state) => {
      state.error = null;
      state.successMessage = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Buscar propostas
      .addCase(fetchUserProposals.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchUserProposals.fulfilled, (state, action) => {
        state.loading = false;
        state.proposals = action.payload.data;
        state.totalItems = action.payload.total;
        state.currentPage = action.payload.current_page;
      })
      .addCase(fetchUserProposals.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error.message;
      })
      // Atualizar dados bancários
      .addCase(updateBankData.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.successMessage = null;
      })
      .addCase(updateBankData.fulfilled, (state, action) => {
        state.loading = false;
        state.successMessage = 'Dados bancários atualizados com sucesso!';
        const { proposalId, bank_data } = action.payload;
        const index = state.proposals.findIndex((p) => p.id === proposalId);
        if (index !== -1) {
          state.proposals[index].bank_data = bank_data;
        }
        state.updatedProposalId = proposalId;
      })
      .addCase(updateBankData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error.message;
      });
  },
});

export const { setCurrentPage, setSearchTerm, setSortDirection, clearUpdatedProposalId, clearMessages } =
  proposalsSlice.actions;

export default proposalsSlice.reducer;
